import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '@/store';

// Separate baseQuery without Content-Type so browser can set multipart/form-data boundary
const uploadBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.accessToken;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    // NOTE: Do NOT set content-type here — fetch/browser sets it automatically for FormData
    return headers;
  },
});

export interface UploadedFileResponse {
  url: string;
  meta: {
    originalname: string;
    filename: string;
    mimetype: string;
    size: number;
  };
}

export const storageApi = createApi({
  reducerPath: 'storageApi',
  baseQuery: uploadBaseQuery,
  endpoints: (builder) => ({
    uploadFile: builder.mutation<UploadedFileResponse, File>({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: '/upload',
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadFileMutation } = storageApi;
